'use client';
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HoverCard = HoverCard;
exports.HoverCardTrigger = HoverCardTrigger;
exports.HoverCardContent = HoverCardContent;
const jsx_runtime_1 = require("react/jsx-runtime");
const HoverCardPrimitive = __importStar(require("@radix-ui/react-hover-card"));
const utils_1 = require("../utils");
function HoverCard(_a) {
    var props = __rest(_a, []);
    return (0, jsx_runtime_1.jsx)(HoverCardPrimitive.Root, Object.assign({ "data-slot": 'hover-card' }, props));
}
function HoverCardTrigger(_a) {
    var props = __rest(_a, []);
    return (0, jsx_runtime_1.jsx)(HoverCardPrimitive.Trigger, Object.assign({ "data-slot": 'hover-card-trigger' }, props));
}
// Hover-triggered surface — same shape as Popover (12px radius, --aiq-shadow-md, neutral-100 border).
// Smaller default width (w-64) for inline content like user cards.
function HoverCardContent(_a) {
    var { className, align = 'center', sideOffset = 4 } = _a, props = __rest(_a, ["className", "align", "sideOffset"]);
    return ((0, jsx_runtime_1.jsx)(HoverCardPrimitive.Portal, { "data-slot": 'hover-card-portal', children: (0, jsx_runtime_1.jsx)(HoverCardPrimitive.Content, Object.assign({ align: align, className: (0, utils_1.cn)('z-50 w-64 rounded-xl border border-neutral-100 bg-surface p-4 text-neutral-900 shadow-md outline-hidden', 'origin-(--radix-hover-card-content-transform-origin)', 'data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0', 'data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95', 'data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2', className), "data-slot": 'hover-card-content', sideOffset: sideOffset }, props)) }));
}
